/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('revenueProductionFlights',{
                parent: 'app',
                url: '/revenueProductionFlights?page&size&departureDate&aircraftId',
                params: {
                    page: "0",
                    size: "50",
                    departureDate: null,
                    aircraftId: ""
                },

                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/revenue/revenueProduction/revenueProductions.html',
                        controller: 'revenueProductionCtrl',
                        controllerAs: 'vm',
                        'resolve': {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['revenuePlanning']);
                            }],
                            'tabRevenue': ['tabService', function(tabService){
                                return tabService.getTabRevenue('revenueProductionFlights')
                            }],
                            'modelAircrafts': ['modelAircraftService', function(modelAircraftService){
                                return modelAircraftService.getModelAircrafts()
                            }],
                            categories: ['tariffClassService',function(tariffClassService){
                                return tariffClassService.getFareClassesFare();
                            }],
                            revenueDate: ['itineraryService','$stateParams', function(itineraryService,$stateParams){
                                return itineraryService.getRevenueByDate($stateParams.id);
                            }],
                            'plaqueAirCrafts': ['aircraftService', function (aircraftService) {
                                return aircraftService.getAircrafts()
                            }],
                            flights: ['itineraryService','$stateParams', function (itineraryService,$stateParams) {
                                if ($stateParams.departureDate == null) {
                                    $stateParams.departureDate = (new Date()).getTime();
                                }
                                return itineraryService.getRevenueByDate($stateParams.departureDate, $stateParams.aircraftId,$stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();


